import * as core from '../../../../../../../core'

import { query } from './edit-proposal-personnel-row.query'

export const RESOURCE = {
  payload: {
    alias: 'edit.proposal.personnel.row',
    description: 'Modal to make changes to a given Proposal-Personnel record',
    name: 'Edit Proposal Personnel Row',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
